import { Box, Button, Stack } from '@mui/material';
import { LeadDto } from '@sr/dto';
import { Field, Form, Formik, FormikProps } from 'formik';
import { TextField } from 'formik-mui';
import { useState } from 'react';
import { DatePickerField } from 'shared/ui/formik-fields/date-picker';
import { LeadCompanyPickerField } from 'shared/ui/formik-fields/lead-company-picker-field';
import { eventsApi } from 'features/events/api';
import { useSnack } from 'shared/ui/snack';
import { FormCardLayout } from 'shared/ui/form/form-card-layout';
import { EventTaskType } from '@sr/dto/dist/src/enums/events';
import { isDateBeforeToday } from 'utils/date-validation';

export type FormData = {
  companyId: number | null,
  content: string,
  dueDate: Date | undefined;
};

type ValidationData = Partial<{ [x in keyof FormData]: string }>;

const initialValues: FormData = {
  companyId: null,
  content: '',
  dueDate: undefined
};

export const LeadEvent = ({ lead }: { lead: LeadDto }) => {
  const { showError, showSuccess } = useSnack();
  const [addEvent] = eventsApi.useAddEventMutation();
  const [formKey, setFormKey] = useState(0);
  const validate = (values: FormData): ValidationData => {
    let validationResult: ValidationData = {};

    if (!values.companyId)
      validationResult.companyId = 'Необходимо выбрать компанию';
    
    if (!values.dueDate)
      validationResult.dueDate = 'Дата контакта не может быть пустой';
      
    if (values.dueDate && isDateBeforeToday(values.dueDate))
      validationResult.dueDate = 'Дата контакта не может быть раньше текущей';
  
    return validationResult;
  };
  const handleSubmit = async (values: FormData) => {
    try {
      await addEvent({
        companyId: values.companyId!,
        dto: {
          taskType: EventTaskType.CASE,
          content: values.content,
          dueDate: values.dueDate,
          leadId: lead.id
        }
      }).unwrap();
      showSuccess('Дело успешно добавлено');
      setFormKey(prev => prev + 1);
    } catch (error) {
      showError('Ошибка при добавлении дела');
    }
  };

  return (
    <Box sx={{ p: 1, pt: 2 }}>
      <Formik
        key={formKey}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}
        validate={validate}
      >
        {(formikProps: FormikProps<FormData>) => (
          <FormCardLayout
            formikProps={formikProps}
            renderForm={() => (
              <>
                <Stack direction="column" spacing={2} sx={{ mt: 2 }}>
                  <Field
                    component={LeadCompanyPickerField}
                    name='companyId'
                    leadId={lead.id}
                  />
                  <Field
                    name='dueDate'
                    component={DatePickerField}
                    label="Дата следующего контакта"
                  />
                  <Field
                    name='content'
                    label='Текст'
                    multiline
                    rows={4}
                    component={TextField}
                  />
                </Stack>
              </>)}
          />)}
      </Formik >
    </Box>
  );
};


export default LeadEvent;
